import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';

import { AppSettings } from 'src/app/app.settings';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { MatDialog } from '@angular/material/dialog';
import { Settings } from 'src/app/app.settings.model';
import { HeaderInterceptorService } from 'src/app/interceptors/header-interceptor';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {

  // constructor() { }


    @ViewChild(DatatableComponent) table: DatatableComponent;
    editing = {};
    rows = [];
    temp = [];
    selected = [];
    loadingIndicator: boolean = true;
    activeFilter = 'unset';
    reorderable: boolean = true;
    columns = [
        {prop: ''},
    ];
    public settings: Settings;
    storeDialog;

    constructor(public dialog: MatDialog, public appSettings: AppSettings,private router: Router, private activatedRoute: ActivatedRoute,private customAxios: HeaderInterceptorService) {
        this.settings = this.appSettings.settings;
        this.getAllFilters();

    }


    ngOnInit() {
    }

    updateFilter(event) {
        const val = event.target.value.toLowerCase();
        const temp = this.temp.filter(function (d) {
            if (d.brandName !== null) {
                return d.brandName.toLowerCase().indexOf(val) !== -1 || !val;
            }
        });
        this.rows = temp;
        this.table.offset = 0;
    }

    updateValue(event, cell, rowIndex) {
        this.editing[rowIndex + '-' + cell] = false;
        this.rows[rowIndex][cell] = event.target.value;
        this.rows = [...this.rows];
    }

    onSelect({selected}) {
        console.log('Select Event', selected, this.selected);
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
    }

    onActivate(event) {
        console.log('Activate Event', event);
    }
    getAllFilters() {
        this.customAxios.get('Customer/GetAllCustomers?companyBranchId=' + JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyBranchId).then((response: any) => {
            if (response.data.completed) {
                this.temp = response.data.payload;
                console.log(this.temp);
                this.rows = response.data.payload
                // this.rows = this.rows.filter (x => {
                //  return x.active === true;
                // })
                this.loadingIndicator = false;
            } else {
                this.loadingIndicator = false;
            }
        });
    }

    openDialog(customerId): void {
        this.customAxios.get(`Customer/DeleteCustomer?id=${customerId}&userId=${JSON.parse(localStorage.getItem("userData")).id}`).then((response) => {
            console.log(response);
            if (response.data.completed) {
                console.log('Store Deleted');
                this.getAllFilters();
            }
        });
    }

    addFilter() {
        this.router.navigate(['/portal/sales/customers/create']);
        // this.storeDialog = this.dialog.open(AddFilterComponent, {
        //     width: '500px',
        // });

        // this.storeDialog.afterClosed().subscribe(() => {
        //     this.getAllFilters();
        // });
    }
    // EditFilter(selectedFilterRow) {
    //     this.storeDialog = this.dialog.open(EditIndexBrandAssociationComponent, {
    //         width: '1500px',
    //         data: {
    //             selectedFilterRow: selectedFilterRow
    //         }
    //     });
    //
    //     this.storeDialog.afterClosed().subscribe(() => {
    //         this.getAllFilters();
    //     });
    // }




}
